export const mySessionsGroupLoading =  ({store})  => store.mySessionsGroupReducer.loading;

export const mySessionsGroupError =  ({store})  => store.mySessionsGroupReducer.error;

export const mySessionsGroupData =  ({store})  => store.mySessionsGroupReducer.data;